import { DelegateProvider } from '../../shared/interfaces/delegate-provider.interface';
import { Game } from '../models/game.model';
import { Promotion } from '../models/promotion.model';

export const kNameOfTesterWindowManagerService = 'TesterWindowManagerService';

// -----------------------------------------------------------------------------
export interface ITesterWindowManagerServiceDelegate {
  onTestingPromotionSet(game: Game, promotion: Promotion, useDevEnv: string);
}

// -----------------------------------------------------------------------------
export interface ITesterWindowManagerService
  extends DelegateProvider<ITesterWindowManagerServiceDelegate> {
  setActivePromotion?(promotion: any);
  promotionAlreadyRunning?(isRunning: boolean);
}
